<template>
  <div class="page page-onlinecourses">
    <div class="page-content">
      <div
        class=""
        :style="{
          background: '#f0f2f5',
        }"
      >
        <div class="width_1200px">
          <el-menu
            class=""
            :default-active="activeKey"
            mode="horizontal"
            background-color="#f0f2f5"
            text-color="#000"
            @select="handleSelect"
          >
            <template>
              <el-menu-item v-for="(v, i) in identityNavMap[userInfo.type]" :key="i" :index="v.code">{{
                v.name
              }}</el-menu-item>
            </template>

            <!-- <template v-else>
              <el-menu-item index="PERSONAL">校内公开课程</el-menu-item>
            </template> -->
            <!-- <el-menu-item v-else-if="userInfo.type === 'STUDENT'" index="CLASS">班级课程</el-menu-item> -->
          </el-menu>
        </div>
      </div>
      <div class="width_1200px">
        <div class="search_div">
          <div
            class="add_resource"
            v-if="activeKey === 'PERSONAL' && ['TEACHER','TEACHER_RESEARCH' ,'REDACT', 'SCHOOL_MANAGER'].includes(userInfo.type)"
            @click="addcourseChange"
          >
            <img :src="require('@/assets/images/resourcePool/icon_1.png')" alt="" />
            <p>新建课程</p>
          </div>
          <div class="search_data">
            <!-- <div class="input_search" v-if="activeKey === 'SCHOOL'">
              <el-input style="width: 244px" v-model="input" placeholder="请输入内容">
                <el-button slot="append" icon="el-icon-search"></el-button>
              </el-input>
            </div> -->
            <template v-if="['TEACHER','TEACHER_RESEARCH', 'SCHOOL_MANAGER'].includes(userInfo.type)">
              <div class="query_criteria" v-for="(v, i) in queryList[activeKey]" :key="i">
                <cmpCheckBox
                  v-model="v.default"
                  @change="checkBoxChange(queryList[activeKey])"
                  :label="v.name"
                  :data="
                    v.type === 'gradeCode'
                      ? [
                          {
                            value: '全部',
                            code: '',
                          },
                          ...gradeList,
                        ]
                      : v.children
                  "
                  class="cmpCheckBox"
                ></cmpCheckBox>
              </div>
            </template>
            <template v-if="['REDACT', 'REVIEW_REDACT', 'FINAL_REDACT'].includes(userInfo.type)">
              <div class="query_criteria" v-for="(v, i) in queryList_1[userInfo.type]" :key="i">
                <cmpCheckBox
                  v-model="v.default"
                  @change="checkBoxChange(queryList_1[userInfo.type])"
                  :label="v.name"
                  :data="
                    v.type === 'gradeCode'
                      ? [
                          {
                            value: '全部',
                            code: '',
                          },
                          ...gradeList,
                        ]
                      : v.children
                  "
                  class="cmpCheckBox"
                ></cmpCheckBox>
              </div>
            </template>
          </div>
        </div>

        <el-row class="onlinecourses-list" type="flex" justify="space-between">
          <el-col :span="6" v-for="(v, i) in myCoursesList" :key="i">
            <my-course-item
              v-if="v.type !== 'seat' && activeKey === 'PERSONAL'"
              :key="i"
              :data="v"
              :editable="editable"
              :isPublic="activeKey === 'PUBLIC'"
              @updateSession="updateSession"
              @update="courseUpdate"
            ></my-course-item>
            <school-course-item
              v-else-if="v.type !== 'seat' && activeKey !== 'PERSONAL'"
              :data="v"
              :editable="editable"
              :isPublic="activeKey === 'PUBLIC'"
              @update="courseUpdate"
            ></school-course-item>
            <div v-else class="seat"></div>
          </el-col>
          <div v-if="myCoursesList.length === 0" class="nodata nodata-courses"></div>
          <el-pagination
            v-if="total > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="pageSize"
            class="pagination"
            layout="prev, pager, next"
            :total="total"
          >
          </el-pagination>

          <!-- <el-pagination class="pagination" background layout="prev, pager, next" :total="1000"> </el-pagination> -->
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
// import course from "./course";
import utils from "@/assets/js/utils.js";
import schoolCourseItem from "@/components/school-course-item.vue";
import myCourseItem from "@/components/my-course-item.vue";
import cmpCheckBox from "@/components/cmp-checkBox.vue";
import publicUrl from "@/assets/js/interface";

export default {
  name: "page-onlinecourses",
  components: {
    // course,
    schoolCourseItem,
    myCourseItem,
    cmpCheckBox,
  },
  data() {
    return {
      pageSize: 8,
      currentPage: 1,
      total: 0,
      input: "",
      activeKey: "PERSONAL",
      loadingCount: 0,
      identityNavMap: {
        TEACHER_RESEARCH: [
          {
            name: "教材标准课程",
            code: "PUBLIC",
          },
          {
            name: "我的课程",
            code: "PERSONAL",
          },
          {
            name: "校内公开课程",
            code: "SCHOOL",
          },
            ],
        TEACHER: [
          {
            name: "教材标准课程",
            code: "PUBLIC",
          },
          {
            name: "我的课程",
            code: "PERSONAL",
          },
          {
            name: "校内公开课程",
            code: "SCHOOL",
          },
            ],
        STUDENT: [
          {
            name: "我的课程",
            code: "PERSONAL",
          },

          {
            name: "校内公开课程",
            code: "SCHOOL",
          },
        ],
        SCHOOL_MANAGER: [
          {
            name: "教材标准课程",
            code: "PUBLIC",
          },
          {
            name: "我的课程",
            code: "PERSONAL",
          },
          {
            name: "校内公开课程",
            code: "SCHOOL",
          },
        ],
        REDACT: [
          {
            name: "我的课程",
            code: "PERSONAL",
          },
        ],
        REVIEW_REDACT: [
          {
            name: "课程",
            code: "PERSONAL",
          },
        ],
        // TEACHER("教师"), STUDENT("学生"), SCHOOL_MANAGER("校管"),
        // REDACT("编辑老师"), REVIEW_REDACT("审核编辑"), FINAL_REDACT("审核负责人");
      },
      queryList: {
        PERSONAL: [
          {
            name: "来源：",
            type: "type",
            default: {
              value: "全部",
              code: "",
            },
            children: [
              {
                value: "全部",
                code: "",
              },
              {
                value: "教材标准课程",
                code: "PUBLIC",
              },
              {
                value: "校内公开课程",
                code: "SCHOOL",
              },
              {
                value: "自制课",
                code: "SELF_MADE",
              },
            ],
          },
          {
            name: "状态：",
            type: "status",
            default: {
              value: "全部",
              code: "",
            },
            children: [
              {
                value: "全部",
                code: "",
              },
              {
                value: "未发布",
                code: "CREATING",
              },
              {
                value: "已上架",
                code: "UP",
              },
              {
                value: "下架",
                code: "DOWN",
              },
              {
                value: "已公开",
                code: "OPEN",
              },
            ],
          },
          {
            name: "年级：",
            type: "gradeCode",
            default: {
              value: "全部",
              code: "",
            },
          },
        ],
        SCHOOL: [
          {
            name: "年级：",
            type: "gradeCode",
            default: {
              value: "全部",
              code: "",
            },
          },
          {
            name: "排序：",
            type: "sort",
            default: {
              value: "最新公开发布",
              code: "UP_TIME_DESC",
            },
            children: [
              {
                value: "最新公开发布",
                code: "UP_TIME_DESC",
              },
              {
                value: "浏览次数最多",
                code: "VIEW_MAX",
              },
              {
                value: "复制次数最多",
                code: "COPY_MAX",
              },
            ],
          },
        ]
      },

      queryList_1: {
        REDACT: [
          {
            name: "审核状态：",
            type: "checkStatus",
            default: {
              value: "全部",
              code: "",
            },
            children: [
              {
                value: "全部",
                code: "",
              },
              {
                value: "初始状态",
                code: "INITIAL",
              },
              {
                value: "待复审",
                code: "WAIT_REVIEW",
              },
              {
                value: "待终审",
                code: "WAIT_FINAL_REVIEW",
              },
              {
                value: "终审通过",
                code: "PASS",
              },
              {
                value: "复审驳回",
                code: "REVIEW_REFUSE",
              },
              {
                value: "终审驳回",
                code: "FINAL_REFUSE",
              },
            ],
          },
          {
            name: "课程状态：",
            type: "status",
            default: {
              value: "全部",
              code: "",
            },
            children: [
              {
                value: "全部",
                code: "",
              },
              {
                value: "草稿",
                code: "CREATING",
              },
              {
                value: "已上架",
                code: "UP",
              },
              {
                value: "已下架",
                code: "DOWN",
              },
            ],
          },
        ],
        REVIEW_REDACT: [
          {
            name: "审核状态：",
            type: "checkStatus",
            default: {
              value: "全部",
              code: "",
            },
            children: [
              {
                value: "全部",
                code: "",
              },
              {
                value: "待复审",
                code: "WAIT_REVIEW",
              },
              {
                value: "待终审",
                code: "WAIT_FINAL_REVIEW",
              },
              {
                value: "终审通过",
                code: "PASS",
              },
              {
                value: "复审驳回",
                code: "REVIEW_REFUSE",
              },
              {
                value: "终审驳回",
                code: "FINAL_REFUSE",
              },
            ],
          },
          {
            name: "课程状态：",
            type: "status",
            default: {
              value: "全部",
              code: "",
            },
            children: [
              {
                value: "全部",
                code: "",
              },
              {
                value: "已上架",
                code: "UP",
              },
              {
                value: "已下架",
                code: "DOWN",
              },
            ],
          },
        ],
        FINAL_REDACT: [
          {
            name: "审核状态：",
            type: "checkStatus",
            default: {
              value: "全部",
              code: "",
            },
            children: [
              {
                value: "全部",
                code: "",
              },
              {
                value: "待终审",
                code: "WAIT_FINAL_REVIEW",
              },
              {
                value: "终审通过",
                code: "PASS",
              },
              {
                value: "终审驳回",
                code: "FINAL_REFUSE",
              },
            ],
          },
          {
            name: "课程状态：",
            type: "status",
            default: {
              value: "全部",
              code: "",
            },
            children: [
              {
                value: "全部",
                code: "",
              },
              {
                value: "已上架",
                code: "UP",
              },
              {
                value: "已下架",
                code: "DOWN",
              },
            ],
          },
        ],
      },
      searchData: {},
      studentCourseList: [],
    };
  },

  watch: {
    coursesInfo: {
      handler(n) {
        this.total = n.totalCount;
      },
      immediate: true,
    },
  },

  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      gradeList: (state) => state.gradeList,
      coursesList: (state) => state.onlinecourses.coursesList,
      coursesInfo: (state) => state.onlinecourses.coursesInfo,
    }),

    myCoursesList() {
      let arr = [];
      arr = [...this.coursesList];
      let colCount = 4;
      return utils.listWith(arr, colCount);
    },
    editable() {
      return (this.userInfo.type === "REDACT" || this.userInfo.type === "TEACHER" || this.userInfo.type ==='TEACHER_RESEARCH') && this.activeKey === "PERSONAL";
    },
  },
  mounted() {
    // 老师进来导航的默认值不同
    if (this.userInfo.type === 'TEACHER' || this.userInfo.type === 'TEACHER_RESEARCH') {
      this.activeKey = 'PUBLIC'
    }
    if (this.$route.query.searchType) {
      this.activeKey = this.$route.query.searchType;
    }

    // session记住筛选条件
    let _searchDataCourse = window.sessionStorage.getItem('searchDataCourse')
    if (Object.keys(JSON.parse(_searchDataCourse) || {}).length) {
      this.activeKey = JSON.parse(_searchDataCourse).activeKey
      this.queryList[this.activeKey] && this.queryList[this.activeKey].forEach((item) => {
        item.default.code = JSON.parse(_searchDataCourse)[item.type] || ''
      })
      this.requestCourseList({ searchData: JSON.parse(_searchDataCourse)  });
      return false
    }
    this.requestCourseList();
    // if (this.userInfo.type === "TEACHER") {
    //   this.getCoursesList({
    //     vm: this.$root,
    //     params: { pageNo: 1, pageSize: 10, gradeCode: "", status: "", type: this.activeKey },
    //   });
    // } else if (this.userInfo.type === "STUDENT") {
    //   this.studentCourse();
    // }
  },
  methods: {
    ...mapActions({
      getCoursesList: "onlinecourses/getCoursesList",
    }),
    // 分页事件
    handleSizeChange(val) {
      this.pageSize = val;
      this.requestCourseList();
    },
    // 分页事件
    handleCurrentChange(val) {
      this.currentPage = val;
      this.requestCourseList();
    },
    //请求课程列表
    requestCourseList(options = {}) {
      this.$nextTick(() => {
        if (!(this.userInfo || {}).type) return false;
        this.getCoursesList({
          vm: this.$root,
          params: {
            identity: (this.userInfo || {}).type || "",
            searchCourseType: this.activeKey,
            data: {
              pageNo: this.currentPage,
              pageSize: this.pageSize,
              ...(options.searchData || {}),
            },
          },
        });
      });
    },
    studentCourse() {
      // 获取学生课程列表
      this.$ajax
        .get(publicUrl.studentCourseList, {
          params: {
            pageNo: 1,
            pageSize: this.pageSize,
          },
        })
        .then((res) => {
          let data = this.$ajaxCheck(res);
          this.studentCourseList = data.result;
        })
        .catch((err) => {
          this.$ajaxError(err);
        })
        .finally(() => {
          this.loadingCount--;
        });
    },

    // 条件筛选
    checkBoxChange(arr) {
      let map = {};
      arr &&
        arr.forEach((v) => {
          map[v.type] = v.default.code;
        });
      this.currentPage = 1;
      this.searchData = map
      this.requestCourseList({ searchData: map });
    },
    // 新建课程
    addcourseChange() {
      this.$router.push({
        path: "/onlinecourses/newCourse",
      });
    },

    handleSelect(key) {
      window.sessionStorage.removeItem('searchDataCourse')
      this.activeKey = key;
      this.pageSize = 8;
      this.currentPage = 1;
      this.total = 0;
      this.requestCourseList();
      // this.getCoursesList({
      //   vm: this.$root,
      //   params: { pageNo: 1, pageSize: 10, gradeCode: "", status: "", type: this.activeKey },
      // });
    },
    courseUpdate() {
      this.requestCourseList();
    },
    updateSession() {
      // 更新记录session信息 记录筛选条件回显
      window.sessionStorage.setItem('searchDataCourse', JSON.stringify({
        activeKey: this.activeKey,
        ...this.searchData
      }))
    },
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/styles/public.less";

.page-onlinecourses {
  .page-content {
    height: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    .search_div {
      width: 100%;
      margin-top: 20px;
      display: flex;
      .add_resource {
        height: 140px;
        cursor: pointer;
        margin-right: 20px;
        width: 140px;
        background-image: linear-gradient(#e9e7f7, #ffffff);
        .flex_align_items;
        flex-direction: column;
        position: relative;
        border-radius: 6px;
        > img {
          width: 114px;
          height: 114px;
        }
        > p {
          position: absolute;
          bottom: 22px;
          font-size: 16px;
          font-family: SourceHanSansCN-Light, SourceHanSansCN;
          font-weight: 300;
          color: #333333;
        }
      }
      .search_data {
        height: 100%;
        background-image: linear-gradient(#ecf5fb, #ffffff);
        border-radius: 6px;
        width: 100%;
        padding: 0 30px;
        position: relative;
        .input_search {
          position: absolute;
          right: 30px;
          bottom: 20px;
        }
        .cmpCheckBox {
          margin: 20px 0;
        }
      }
    }

    .onlinecourses-list {
      // overflow: hidden auto;
      margin: 15px 0;
      flex-wrap: wrap;
      .pagination {
        text-align: center;
        width: 100%;
      }

      .seat {
        height: 1px;
        visibility: hidden;
      }
    }
    .el-pagination {
      text-align: center;
      margin: 20px;
    }
  }
}
</style>
